
(function () {
    'use strict';

    angular
        .module('app')
        .factory('authService', ['$http', '$q', 'localStorageService', '$rootScope', '$location', 'appData', 'trackingService', authService]);

    function authService($http, $q, localStorageService, $rootScope, $location, appData, trackingService) {

        var authentication = {
            isAuth: false,
            token: '',
            userId: '',
            userName: '',
            role: '',
            expiration: null
        },
            format = 'YYYY-MM-DD HH:mm';

        function register(registration) {
            return $http.post(appData.applicationRoot + 'api/account/register', registration).then(function (response) {
                return response;
            });
        };

        function login(loginData) {
            var data = 'grant_type=password&username=' + window.encodeURIComponent(loginData.userName) + '&password=' + window.encodeURIComponent(loginData.password);

            var deferred = $q.defer();

            $http.post(appData.applicationRoot + 'token',
                data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } })
                .success(function (response) {

                    if (!response.access_token) {
                        logout();
                        deferred.reject();
                        return;
                    }

                    authentication.isAuth = true;
                    authentication.token = response.access_token;
                    authentication.userId = response.userId;
                    authentication.userName = response.userName;
                    authentication.role = response.role;
                    authentication.expiration = moment().add(response.expires_in, 'seconds').format(format);

                    localStorageService.set('authorizationData', authentication);

                    $rootScope.$broadcast('auth:change');
                    trackingService.trackEvent('Log in');

                    deferred.resolve(response);

                })
                .error(function (err) {
                    logout();
                    deferred.reject(err);
                });

            return deferred.promise;
        };

        function logout() {
            var model = {
                email: authentication.userName
            };
            $http.post(appData.applicationRoot + 'api/account/logout', model).then(function () {
                localStorageService.remove('authorizationData');

                authentication.isAuth = false;
                authentication.token = '';
                authentication.userId = '';
                authentication.userName = '';
                authentication.role = '';
                authentication.expiration = null;
            });
            $location.path('/login');
        };

        function initialize() {

            var authData = localStorageService.get('authorizationData');
            if (authData) {

                authentication.isAuth = true;
                authentication.token = authData.token;
                authentication.userName = authData.userName;
                authentication.userId = authData.userId;
                authentication.role = authData.role;
                authentication.expiration = authData.expiration;

                if (moment().isAfter(authentication.expiration)) {
                    logout();
                    return;
                }

                $rootScope.$broadcast('auth:change');
            }

        };

        return {
            login: login,
            logout: logout,
            initialize: initialize,
            register: register,
            authentication: authentication
        }
    };

})();